import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';

const resource = `${Config.basePath}/whitelist-ip-config`;

export default {
  get() {
    return Client.get(`${resource}`);
  },
  update(payload) {
    return Client.put(`${resource}`, payload);
  },
};